import React from "react";
import { Box, Container, Grid, Typography, Chip } from "@mui/material";
import { motion } from "framer-motion";
import TravelReels from "../FillerComponents/TravelReels";


const VideoShowcase = ({
  bannerTitle = "Explore Our Journey",
  bannerSubtitle = "Watch how we create unforgettable experiences",
  videoUrl = "https://www.youtube.com/embed/37qM0UnjC1s",
}) => {
  return (
    <Box sx={{ bgcolor: "#F9FAFB", py: 10, color: "#1F2937" }}>
      
      {/* ================= EMERALD BANNER ================= */}
      <Box
        sx={{
          bgcolor: "#065F46",
          py: 6,
          textAlign: "center",
          color: "white",
          mb: 8,
          borderRadius: { xs: 0, md: 2 },
          boxShadow: 2,
        }}
      >
        <Typography
          variant="overline"
          sx={{ 
            color: "rgba(255,255,255,0.8)", 
            fontWeight: 600, 
            letterSpacing: 2, 
            textTransform: 'uppercase',
            display: 'block',
            mb: 1
          }}
        >
          Cinematic Experience
        </Typography>
        <Typography variant="h3" fontWeight={700} sx={{ fontSize: { xs: "2rem", md: "3rem" } }}>
          {bannerTitle}
        </Typography>
        <Typography variant="body1" sx={{ opacity: 0.8, mt: 1 }}>
          {bannerSubtitle}
        </Typography>
      </Box>
      
             <Box>
              <TravelReels/>
              </Box>
         
      {/* ================= CONTENT ================= */}
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          
          {/* -------- LEFT TEXT -------- */}
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Chip 
                label="Before You Travel" 
                size="small" 
                sx={{ 
                  bgcolor: "#ECFDF5", 
                  color: "#065F46", 
                  fontWeight: 700, 
                  mb: 2 
                }} 
              />
              
              <Typography 
                variant="h4" 
                fontWeight="800" 
                color="#064E3B" 
                sx={{ mb: 3, lineHeight: 1.2 }}
              >
                Experience the Journey Before You Pack
              </Typography>

              <Typography 
                variant="body1" 
                color="#6B7280" 
                sx={{ lineHeight: 1.7, mb: 2 }}
              >
                We believe travel should be transparent, exciting, and trustworthy. 
                Through our video experiences, you get a real look into destinations, 
                accommodations, and the overall journey.
              </Typography>

              <Typography 
                variant="body1" 
                color="#6B7280" 
                sx={{ lineHeight: 1.7 }}
              >
                Watch the video to see real moments, genuine experiences, and the passion 
                behind every journey we organize.
              </Typography>

              <Typography 
                sx={{ 
                  mt: 4, 
                  color: "#065F46", 
                  fontWeight: "bold", 
                  display: "inline-flex", 
                  alignItems: "center",
                  cursor: "pointer",
                  "&:hover": { textDecoration: "underline" }
                }}
              >
                Learn more about our process <span style={{ marginLeft: 8 }}>→</span>
              </Typography>
            </motion.div>
          </Grid>

          {/* -------- RIGHT VIDEO -------- */}
          <Grid item xs={12} md={6} sx={{ order: { xs: -1, md: 0 } }}>
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
            >
              <Box
                sx={{
                  position: "relative",
                  paddingTop: "56.25%", // 16:9 Aspect Ratio
                  borderRadius: "16px",
                  overflow: "hidden",
                  boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                  border: "4px solid white"
                }}
              >
                <iframe
                  src={videoUrl}
                  title="YouTube video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                  }}
                />
              </Box>
            </motion.div>
          </Grid>

        </Grid>
      </Container>
    </Box>
  );
};

export default VideoShowcase;